import React, { useState, useEffect } from 'react';
import SetProductDialog from '@setproduct-ui/core/Dialog';
import { useLocation } from 'react-router-dom';
import * as Routes from 'app/constants/Routes';
import '../css/ReferralSourceModal.scss';
import '../css/BillingIssueModal.scss';

const ModalTitle = () => 'Houston, we have a problem 🚀';

const ModalBody = ({ message }) => (
  <>
    <p>
      There is an unresolved billing issue on your account, but don{'’'}t sweat it: we{'’'}re here to help.
    </p>
    <p>
      Billing issue reason: <span className="billing-issue-message">"{message}"</span>
    </p>
    <p>To resolve the billing issue:</p>
    <ul>
      <li>
        Go to the{' '}
        <button
          className="billing-issue-link"
          onClick={() => {
            window.location.href = Routes.BillingSettings;
          }}
        >
          shipping/billing preferences
        </button>{' '}
        page (located in Settings).
      </li>
      <li>Enter your updated card info and billing address (if different than shipping), and submit.</li>
      <li>Voila! You will receive immediate confirmation whether the new billing info was accepted.</li>
    </ul>
    <p>
      Please note: some billing issues may need to be resolved through your bank. For instance, you may need to contact
      your bank to ensure Maximus is recognized as an accepted entity to make charges.
    </p>
    <p>
      If you continue to have issues, let us know and one of our concierges will help you resolve the issue:{' '}
      <a href="mailto:support@maximustribe.com">support@maximustribe.com</a>
    </p>
  </>
);

const BillingIssueModal = ({ message }) => {
  const [dialogOpen, setDialogOpen] = useState(true);
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname === Routes.BillingSettings) {
      setDialogOpen(false);
    }
  }, [pathname]);

  return (
    <SetProductDialog
      isOpen={dialogOpen}
      onClose={() => setDialogOpen(false)}
      title={<ModalTitle />}
      text={<ModalBody message={message} />}
      className="referral-source-modal billing-issue"
    />
  );
};

export default BillingIssueModal;
